"use client"
import { useContext, useState } from "react"
import { FeatureFlagContext } from "./FeatureFlagProvider"

export const useFeatureFlag = (flags: string[] = []) => {
  const { featureFlags, isEnabled } = useContext(FeatureFlagContext)
  const [enabled] = useState(isEnabled(flags))
  return { enabled, isEnabled, featureFlags }
}
